import { useCallback, useEffect, useRef } from 'react'
import type { GaFormEventTypeModel, GaFormStartModel } from '../types'
import type { GaFormProps } from './GaForm'

interface Props extends GaFormProps {
  formRef: React.RefObject<HTMLFormElement>
  pushToDataLayer: (model: GaFormEventTypeModel) => void
}

export const useFormStart = (props: Props) => {
  const { formRef, pushToDataLayer } = props
  const hasFormStarted = useRef(false)

  const getFormLength = useCallback(() => {
    if (!formRef.current) return 0
    return formRef.current.querySelectorAll('input, textarea, select').length
  }, [])

  const handleFormStart = useCallback(() => {
    if (!hasFormStarted.current) {
      hasFormStarted.current = true

      const formLength = getFormLength()
      const model: GaFormStartModel = {
        formName: props.formName,
        formId: props.formId,
        formDestination: props.formDestination,
        formLength: formLength,
        event: 'formStart',
      }

      pushToDataLayer(model)
    }
  }, [pushToDataLayer, getFormLength])

  useEffect(() => {
    if (!formRef.current) return

    const inputs = formRef.current.querySelectorAll(
      'input, textarea, select, button',
    )

    inputs.forEach((el) => {
      el.addEventListener('focus', handleFormStart)
      el.addEventListener('change', handleFormStart)
    })

    return () => {
      inputs.forEach((el) => {
        el.removeEventListener('focus', handleFormStart)
        el.removeEventListener('change', handleFormStart)
      })
    }
  }, [handleFormStart])
}
